export const GET_SPOTLIGHT_REQUEST = 'GET_SPOTLIGHT_REQUEST';
export const GET_SPOTLIGHT_SUCCESS = 'GET_SPOTLIGHT_SUCCESS';
export const GET_SPOTLIGHT_ERROR = 'GET_SPOTLIGHT_ERROR';
export const RESET_STATE = 'RESET_STATE';
